import { Checkbox, FormGroup } from "@blueprintjs/core";
import { ItemGridFilter, type ItemGridFilterProps } from "./ItemGridFilter";

type ItemGridFilterBooleanProps = Omit<
  ItemGridFilterProps,
  "onClickFilterReset" | "children"
> & {
  checked?: boolean;
  onRequestFilterReset: () => void;
  onRequestFilterUpdate: () => void;
};

export function ItemGridFilterBoolean({
  checked,
  property,
  text,
  onRequestFilterReset,
  onRequestFilterUpdate,
}: ItemGridFilterBooleanProps) {
  return (
    <ItemGridFilter
      property={property}
      onClickFilterReset={() => onRequestFilterReset()}
      text={text}
    >
      <FormGroup
        helperText={
          checked
            ? "All items which are enabled"
            : checked === false
              ? "All items which are disabled"
              : "All items"
        }
      >
        <Checkbox
          checked={!!checked}
          className="text-ellipsis whitespace-nowrap outline-none"
          indeterminate={typeof checked !== "boolean"}
          label={text}
          title={text}
          onChange={() => {
            onRequestFilterUpdate();
          }}
        />
      </FormGroup>
    </ItemGridFilter>
  );
}
